import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import ReactToPrint, { useReactToPrint } from "react-to-print";
import Loader from "./Loader";
import { Pdf } from "./Pdf";
import ViewPdf from "./ViewPdf";
import { fetchDashboardAction } from "../../../../redux/actions/dashboard/dashboardAction";

export const PdfResume = (props) => {
  const componentRef = useRef();
  const [showGeneratePdfButton, setShowGeneratePdfButton] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        await props.fetchDashboard();
        setTimeout(() => {
          setShowGeneratePdfButton(true);
          setLoading(false); 
        }, 2000);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false); 
      }
    }
    fetchData();
  }, [props.fetchDashboard]);


  const currentDate = new Date();
  const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, "0")}-${currentDate.getFullYear()}`;



  const pdfFileName =
  props.profile !== undefined
    ? `${props.profile.first_name}_${props.profile.last_name}_${formattedDate}`
    : "Neet";



  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: pdfFileName,
  });

  return (
    <>
      {loading ? ( 
        <Loader />
      ) : (
        <>
          {props.profile && props.profile.profile_fill === 100 ? (
            <>
              {showGeneratePdfButton && (
               
                <button
                type="submit"
                className="btn btn-blue"
                onClick={handlePrint}
              >
                Generate PDF
              </button>

              )}
              <div style={{ position: "absolute", left: "-5000px" }}>
                <Pdf
                  ref={componentRef}
                  data={props.data}
                  donutData={props?.dashboard}
                  profile={props.profile}
                  paid={props.user.is_paid}
                  experience={props.dashboard.primary_job_title_years_experience}
                />
              </div>
              <ViewPdf
                data={props.data}
                donutData={props?.dashboard}
                profile={props.profile}
                paid={props.user.is_paid}
                experience={props.dashboard.primary_job_title_years_experience}
              />
            </>
          ) : (
            <div>Please complete your profile to 100% to generate CV</div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const dashboard = state.dashboard.dashboard;
  const profile = state.user.profile;
  const user = state.user.user
// console.log(state);
  return {
    dashboard: dashboard,
    profile: profile,
    user:user
  };
};
const mapDispatchToProps = (dispatch, state) => {
  return {
    fetchDashboard: () => dispatch(fetchDashboardAction()),
  
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PdfResume);










// import React, { useEffect, useRef, useState } from "react";
// import { connect } from "react-redux";
// import ReactToPrint from "react-to-print";
// import Loader from "./Loader";
// import { Pdf } from "./Pdf";
// import ViewPdf from "./ViewPdf";
// import { fetchDashboardAction } from "../../../../redux/actions/dashboard/dashboardAction";

// export const PdfResume = (props) => {
//   const componentRef = useRef();
//   const [showGeneratePdfButton, setShowGeneratePdfButton] = useState(false);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         await props.fetchDashboard();
//         setTimeout(() => {
//           setShowGeneratePdfButton(true);
//           setLoading(false); 
//         }, 2000);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//         setLoading(false); 
//       }
//     }
//     fetchData();
//   }, [props.fetchDashboard]);

//   return (
//     <>
//       {loading ? ( 
//         <Loader />
//       ) : (
//         <>
//           {props.profile && props.profile.profile_fill === 100 ? (
//             <>
//               {showGeneratePdfButton && (
//                 <ReactToPrint
//                   trigger={() => (
//                     <button type="submit" className="btn btn-blue">
//                       Generate Pdf
//                     </button>
//                   )}
//                   content={() => componentRef.current}
//                 />
//               )}
//               <div style={{ position: "absolute", left: "-5000px" }}>
//                 <Pdf
//                   ref={componentRef}
//                   data={props.data}
//                   donutData={props?.dashboard}
//                   profile={props.profile}
//                   paid={props.user.is_paid}
//                   experience={props.dashboard.primary_job_title_years_experience}
//                 />
//               </div>
//               <ViewPdf
//                 data={props.data}
//                 donutData={props?.dashboard}
//                 profile={props.profile}
//                 paid={props.user.is_paid}
//                 experience={props.dashboard.primary_job_title_years_experience}
//               />
//             </>
//           ) : (
//             <div>Please complete your profile to 100% to generate CV</div>
//           )}
//         </>
//       )}
//     </>
//   );
// };

// const mapStateToProps = (state) => {
//   const dashboard = state.dashboard.dashboard;
//   const profile = state.user.profile;
//   const user = state.user.user
// // console.log(state);
//   return {
//     dashboard: dashboard,
//     profile: profile,
//     user:user
//   };
// };
// const mapDispatchToProps = (dispatch, state) => {
//   return {
//     fetchDashboard: () => dispatch(fetchDashboardAction()),
  
//   };
// };
// export default connect(mapStateToProps, mapDispatchToProps)(PdfResume);
